import type { IAssistantAccessRevokedNotificationData } from "@frontend-shared/types";
import { UserMinus } from "lucide-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";

import { NotificationCardShell } from "../NotificationCardShell";

interface IAssistantAccessRevokedCardProps {
  uuid: string;
  data: IAssistantAccessRevokedNotificationData;
  createdAt: string;
  isRead: boolean;
}

const AssistantAccessRevokedCardComponent = ({
  uuid,
  data,
  createdAt,
  isRead,
}: IAssistantAccessRevokedCardProps): React.JSX.Element => {
  const { t } = useTranslation("notifications");

  return (
    <NotificationCardShell
      uuid={uuid}
      variantTestId="assistant_access_revoked"
      createdAt={createdAt}
      isRead={isRead}
      icon={<UserMinus className="h-5 w-5 text-destructive" />}
      iconBgClassName="bg-destructive/10"
      body={t("type.assistant_access_revoked.body", {
        ownerName: data.ownerName,
        assistantName: data.assistantName,
      })}
    />
  );
};

export const AssistantAccessRevokedCard = memo(
  AssistantAccessRevokedCardComponent,
);
